<template>
    <div id="security">
        <h1>{{ $i18n.t('pages.security.title') }}</h1>
        <admin-settings :users="users_data" :roles="roles_data" class="mb-2" v-if="$store.state.user.role_name === 'admin'"/>
        <v-spacer/>
        <users-settings  :users="users_data" :roles="roles_data" v-if="users_data !== ''" style="margin-top: 20px"/>
        <div class="plus-button-component-positioning">
          <v-btn
            v-if="$store.state.user.role_name === 'admin'"
            class="white--text rounded-plus-button"
            elevation="0"
            fab
            width="72px"
            height="72px"
            @click="add_user"
          >
            <v-icon size="72px">$icon_rounded_plus</v-icon>
          </v-btn>
        </div>
    </div>
</template>

<script>
import UsersSettings from "../components/UsersSettings";
import AdminSettings from "../components/AdminSettings";
import {mapActions} from "vuex";
import {i18n} from "@/i18n";
import {EventBus} from "@/bus";

export default {
  name: "SecurityPage",
  components: {
      AdminSettings,
      UsersSettings,
  },
  data: function () {
    this.fetch_roles_data()
    this.fetch_users_data()
    return {
      roles_data: [],
      users_data: [],
    }
  },
  methods: {
     fetch_roles_data: function () {
        this.$http({url: this.$http_hostname + '/users/all_user_roles', method: 'GET'})
        .then(resp => {
          this.roles_data=resp.data
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
        })
     },
     fetch_users_data: function () {
       this.$http({url: this.$http_hostname + '/users/all_users', method: 'GET'})
        .then(resp => {
          this.users_data=resp.data
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
        })
     },
    add_user: function () {
       EventBus.$emit('users_event', {event_name: 'add_user'})
    },
    ...mapActions(['setSnackbar'])
  }
}
</script>

<style>

</style>